var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, } from 'react';
import Icon from '../../../icon';
import { NavigationContext } from '../../provider';
import { NavigationSubItemsToggleContainer, NavigationSubItemsToggleContent, } from './styles/navigation-sub-items-toggle.styled';
const MOUSE_DELAY = 200;
export const NavigationSubItemsToggle = (_a) => {
    var { children, reference, label, href, highlighted, onClick, onMouseEnter, dataTest = 'navigation-sub-item-toggle' } = _a, props = __rest(_a, ["children", "reference", "label", "href", "highlighted", "onClick", "onMouseEnter", "dataTest"]);
    const { activeItemReference, setActiveItemReference, navigationViewportBreakpoint, addItemToRegistry, setFocusedNavigationElement, isKeyboardNavigating, } = useContext(NavigationContext);
    const isMobileViewports = ['xxs', 'xs', 'sm', 'md'].includes(navigationViewportBreakpoint);
    let timeout;
    // prevent flicker on SSR apps on desktop by showing desktop styles on SSR
    const typographyVariant = typeof window === 'undefined'
        ? 'button-link-xs'
        : isMobileViewports
            ? 'button-link'
            : 'button-link-xs';
    useEffect(() => {
        addItemToRegistry(reference, label, href);
    }, [addItemToRegistry, href, label, reference]);
    if (isMobileViewports && activeItemReference === reference) {
        return null;
    }
    const handleKeyboard = (event) => {
        if (event.code === 'Enter' || event.code === 'Space') {
            setFocusedNavigationElement(event.target);
        }
    };
    const handleMouseEnter = (e) => {
        timeout = window.setTimeout(() => {
            if (onMouseEnter) {
                onMouseEnter(e);
            }
            if (!isMobileViewports) {
                setActiveItemReference(reference);
            }
        }, MOUSE_DELAY);
    };
    const handleMouseLeave = () => {
        clearTimeout(timeout);
    };
    return (_jsxs(NavigationSubItemsToggleContainer, Object.assign({ "$anyIsActive": !!activeItemReference, "$isActive": activeItemReference === reference, "$isHighlighted": highlighted && activeItemReference === null, variant: typographyVariant, tagName: "button", onKeyPress: handleKeyboard, onClick: (e) => {
            if (onClick) {
                onClick(e);
            }
            if (isMobileViewports) {
                setActiveItemReference(activeItemReference === reference ? null : reference);
            }
            else {
                setActiveItemReference(reference);
            }
        }, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, "data-test": dataTest }, (!isMobileViewports && !isKeyboardNavigating && { href, tagName: 'a' }), props, { children: [_jsx(NavigationSubItemsToggleContent, { children: children }), !activeItemReference && _jsx(Icon, { variant: "chevron-right", size: "lg" })] })));
};
